const superAdminEn = {
    company: require('../../lang/en/superAdmin/Company').default,
    companyUser: require('../../lang/en/superAdmin/CompanyUser').default,
}

export default superAdminEn;

